import { render } from "./createDriveFileTypeComponent.vue?vue&type=template&id=918d8758"
import script from "./createDriveFileTypeComponent.vue?vue&type=script&lang=js"
export * from "./createDriveFileTypeComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__